(function () {
  var THEME_STORAGE_KEY = 'blog-hub-theme';

  function normalizeHash() {
    var h = window.location.hash || '';
    return h.charAt(0) === '#' ? h.slice(1) : h;
  }

  function setPanelsInert(panel, isActive) {
    if ('inert' in panel) {
      panel.inert = !isActive;
    }
  }

  function activatePanel(root, handle, updateHash) {
    var tabs = root.querySelectorAll('[data-blog-hub-tab]');
    var panels = root.querySelectorAll('[data-blog-hub-panel]');
    var targetPanel = null;

    panels.forEach(function (panel) {
      var ph = panel.getAttribute('data-blog-handle');
      if (ph === handle) {
        targetPanel = panel;
      }
    });

    if (!targetPanel && panels.length) {
      targetPanel = panels[0];
    }

    if (!targetPanel) return;

    var currentActive = root.querySelector('[data-blog-hub-panel].is-active');
    var activeHandle = targetPanel.getAttribute('data-blog-handle');

    if (currentActive === targetPanel) {
      if (updateHash && activeHandle) {
        var next = '#' + activeHandle;
        if (window.location.hash !== next) {
          history.replaceState(null, '', next);
        }
      }
      panels.forEach(function (panel) {
        setPanelsInert(panel, panel === targetPanel);
      });
      return;
    }

    panels.forEach(function (panel) {
      var isActive = panel === targetPanel;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      setPanelsInert(panel, isActive);
    });

    tabs.forEach(function (tab) {
      var th = tab.getAttribute('data-blog-handle');
      var active = th === activeHandle;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    var titleEl = root.querySelector('[data-blog-hub-active-title]');
    if (titleEl) {
      var t = targetPanel.getAttribute('data-panel-title');
      if (t) titleEl.textContent = t;
    }

    if (updateHash && activeHandle) {
      var nextHash = '#' + activeHandle;
      if (window.location.hash !== nextHash) {
        history.replaceState(null, '', nextHash);
      }
    }

    var searchInput = root.querySelector('[data-blog-hub-search-input]');
    filterCards(root, searchInput ? searchInput.value : '');
  }

  function getBlogHubSectionEl(root) {
    var sid = root.getAttribute('data-blog-hub-section-id');
    if (sid) {
      var byId = document.getElementById('shopify-section-' + sid);
      if (byId) return byId;
    }
    return root.closest('[id^="shopify-section-"]');
  }

  function applyBlogHubTheme(root, isLight, persist) {
    var sectionEl = getBlogHubSectionEl(root);
    root.classList.toggle('blog-hub--light', isLight);
    if (sectionEl) {
      sectionEl.classList.toggle('blog-hub-light-section', isLight);
      sectionEl.classList.toggle('blog-hub-dark-section', !isLight);
    }
    root.querySelectorAll('[data-blog-hub-theme-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-pressed', isLight ? 'true' : 'false');
    });
    if (persist === true) {
      try {
        localStorage.setItem(THEME_STORAGE_KEY, isLight ? 'light' : 'dark');
      } catch (e) {}
    }
  }

  function readStoredBlogHubTheme() {
    try {
      return localStorage.getItem(THEME_STORAGE_KEY) !== 'dark';
    } catch (e) {
      return true;
    }
  }

  function filterCards(root, query) {
    var panel = root.querySelector('[data-blog-hub-panel].is-active');
    if (!panel) return;
    var q = (query || '').trim().toLowerCase();
    var cards = panel.querySelectorAll('[data-blog-hub-card]');
    cards.forEach(function (card) {
      var hay = card.getAttribute('data-search-blob') || '';
      var match = !q || hay.indexOf(q) !== -1;
      card.classList.toggle('is-filtered-out', !match);
    });
  }

  function init(root) {
    var tabs = root.querySelectorAll('[data-blog-hub-tab]');
    var searchToggles = root.querySelectorAll('[data-blog-hub-search-toggle]');
    var searchPanel = root.querySelector('[data-blog-hub-search-panel]');
    var searchInput = root.querySelector('[data-blog-hub-search-input]');
    var themeToggles = root.querySelectorAll('[data-blog-hub-theme-toggle]');

    applyBlogHubTheme(root, readStoredBlogHubTheme(), false);

    if (themeToggles.length) {
      themeToggles.forEach(function (themeToggle) {
        themeToggle.addEventListener('click', function () {
          applyBlogHubTheme(root, !root.classList.contains('blog-hub--light'), true);
        });
      });
    }

    var hash = normalizeHash();
    var handles = [];
    root.querySelectorAll('[data-blog-hub-panel]').forEach(function (p) {
      var h = p.getAttribute('data-blog-handle');
      if (h) handles.push(h);
    });
    var initial = hash && handles.indexOf(hash) !== -1 ? hash : handles[0];
    if (initial) activatePanel(root, initial, false);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var h = tab.getAttribute('data-blog-handle');
        if (!h) return;
        var si = root.querySelector('[data-blog-hub-search-input]');
        if (si) si.value = '';
        activatePanel(root, h, true);
      });
    });

    window.addEventListener('hashchange', function () {
      var h = normalizeHash();
      if (h && handles.indexOf(h) !== -1) activatePanel(root, h, false);
    });

    if (searchToggles.length && searchPanel) {
      searchToggles.forEach(function (searchToggle) {
        searchToggle.addEventListener('click', function () {
          var open = searchPanel.hidden;
          searchPanel.hidden = !open;
          searchToggles.forEach(function (st) {
            st.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          if (open && searchInput) {
            searchInput.focus();
          }
        });
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterCards(root, searchInput.value);
      });
    }
  }

  document.querySelectorAll('[data-blog-hub-root]').forEach(init);
})();
